import {Popup} from '../modules/Popup';

var uPopupFunc = function (root, doc) {
	if(root.uPopup) return false;

	var uPopup = function(param){
		if(!param.name) param.name = 'popup-' + new Date().getTime();
		if(!uPopup.all[param.name]) uPopup.all[param.name] = new Popup(param);
		uPopup.all[param.name].open();
		return uPopup.all[param.name];
	}

	uPopup.count = 0;
	uPopup.all = {};
	uPopup.closeAll = function() {
		for (var name in uPopup.all) {
			uPopup.all[name].close();
		}
	}

	root.uPopup = uPopup;
};

export {uPopupFunc};



